import validate from "/vercel/path0/nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45trailing_45slash_45global from "/vercel/path0/nuxt/middleware/redirect-trailing-slash.global.js";
import manifest_45route_45rule from "/vercel/path0/nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  redirect_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}